module.exports = __webpack_public_path__ + "img/switch-double.a4c61926.svg";